export default __webpack_public_path__ + "static/soehne-web-kraftig-kursiv-93c2071e57ba73af0b3cb05e37be6057.woff2";